<template>
  <div class="campos-box">
    <div
      class="campos-header"
      role="button"
      tabindex="0"
      :aria-expanded="aberto ? 'true' : 'false'"
      @click="aberto = !aberto"
      @keydown.enter.prevent="aberto = !aberto"
      @keydown.space.prevent="aberto = !aberto"
    >
      <span class="campos-titulo">
        <fa-icon :icon="aberto ? 'chevron-down' : 'chevron-right'" class="chevron" />
        CAMPOS
      </span>
      <span class="campos-count">{{ chips.length }}</span>
    </div>

    <div v-if="aberto" class="campos-body">
      <p v-if="!chips.length" class="campos-vazio">
        Selecione uma view sincronizável para listar os campos.
      </p>
      <div v-else class="campos-chips">
        <span
          v-for="chip in chips"
          :key="chip.nome"
          class="campo-chip"
          :class="{ 'campo-chip--ativo': chip.ativo }"
          :title="chip.ativo ? 'Presente no SQL — clique para inserir novamente' : 'Ainda não usado no SQL — clique para inserir'"
          @click="$emit('inserir', chip.nome)"
        >
          {{ chip.nome }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { extractAliases } from "@/helpers/sql/sqlErpHelpers";

export default {
  name: "CamposAccordion",
  props: {
    // Campos fillable da view selecionada (quando sincronizável).
    campos: { type: Array, default: () => [] },
    // SQL atual, para detectar quais campos já aparecem como alias (AS ...).
    sql: { type: String, default: "" },
  },
  data() {
    return { aberto: false };
  },
  computed: {
    aliasesNoSql() {
      return extractAliases(this.sql);
    },
    chips() {
      // Com fillables: lista todos, coloridos conforme presença no SQL.
      if (this.campos && this.campos.length) {
        return this.campos.map((nome) => ({
          nome,
          ativo: this.aliasesNoSql.has(String(nome).toUpperCase()),
        }));
      }
      // Sem fillables (view custom): usa os próprios aliases do SQL, todos ativos.
      return [...this.aliasesNoSql].map((nome) => ({ nome, ativo: true }));
    },
  },
};
</script>

<style scoped>
.campos-box {
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}

.campos-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px;
  cursor: pointer;
  user-select: none;
}

.campos-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  color: #5a6072;
}

.chevron {
  color: #949aa8;
  font-size: 11px;
}

.campos-count {
  font-size: 12px;
  font-weight: 700;
  color: #5a6072;
  border: 1px solid #d3d8e0;
  border-radius: 6px;
  padding: 1px 8px;
  font-variant-numeric: tabular-nums;
}

.campos-body {
  padding: 0 14px 12px;
}

.campos-vazio {
  font-size: 12px;
  color: #949aa8;
  margin: 0;
}

.campos-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-height: 220px;
  overflow-y: auto;
  padding-right: 2px;
}

.campo-chip {
  font-family: SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 5px;
  cursor: pointer;
  /* Padrão: ainda não usado no SQL — cinza claro */
  background: #f2f4f7;
  color: #949aa8;
  border: 1px solid #e4e7ec;
}

.campo-chip--ativo {
  /* Presente no SQL — colorido (teal) */
  background: #edf8f9;
  color: #1a7a83;
  border-color: #c5e6e9;
}

.campo-chip:hover {
  filter: brightness(0.97);
}
</style>
